import { atom, RecoilState } from 'recoil';

export interface DebugInfoEntry {
  recorded_at: string;
  content: string;
}

export const debugInfoState: RecoilState<DebugInfoEntry[]> = atom<DebugInfoEntry[]>({
  key: 'DebugInfo',
  default: []
});

export const debugInfoOpenState: RecoilState<boolean> = atom<boolean>({
  key: 'DebugInfoOpen',
  default: false
});
